import React from "react";
import { HomeContent } from "pages/Home/Home.styled";
import { Paragraph, Title } from "components/Text";
import { Layout } from "components/Layout/Layout.styled";
import image from "assets/index.jpg";

const Home = () => {
  return (
    <Layout
      className="home-container py-5"
      style={{
        background: `url(${image})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: "70vh",
      }}
    >
      <HomeContent className="home-content py-5">
        <div
          className="container text-center d-flex align-items-center justify-content-center"
          style={{ height: "50vh" }}
        >
          <div>
            <Title style={{ color: "white" }}>Registro de Consultores</Title>
            <Paragraph color="white">
              El contenido de esta página aún está en construcción. Puedes
              revisar el listado de consultores en el menú{" "}
              <strong>Consultores</strong>.
            </Paragraph>
          </div>
        </div>
      </HomeContent>
    </Layout>
  );
};

export default Home;
